import { render, staticRenderFns } from "./AllowanceForm.vue?vue&type=template&id=ab823410&scoped=true"
import script from "./AllowanceForm.vue?vue&type=script&lang=js"
export * from "./AllowanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab823410",
  null
  
)

export default component.exports